export enum Permissions {
    AccessBusinessPortal,
    AccessEventLogs,
    AccessImportExport,
    AccessReports,
    ManageAllCollections,
    ManageAssignedCollections,
    ManageGroups,
    ManageOrganization,
    ManagePolicies,
    ManageUsers,
    ManageUsersPassword,
}
